// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"AsideSection_borderTop__B7AvZ"};